import Accordion from './accordion.js';

let scrollOffset = 50;

if (window.innerWidth > 767) {
  scrollOffset = 70;
}

export default class FaqSection extends Accordion {
  constructor(agendaEl) {
    super(agendaEl, {
      activeClass: 'event-agenda__day-header--expanded',
      questionSelector: '.event-agenda__day-header',
      answerSelector: '.event-agenda__day-schedule',
      scrollOffset,
      initWithExpandedIndex: 0,
    });
  }

}
